export enum DeeplinkKeys {
  tool = 'tool',
  taskId = 'task_id',
  fileUid = 'file_uid',
  presetId = 'presetId',
  projectId = 'projectId',
  category = 'genaicategory',
  socialShareState = 'state',
  presetJsonUrl = 'presetJsonUrl',
  hideBackButton = 'hideBackButton',
  openChooser = 'openChooser',
  seeAll = 'seeAll',
}
